"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function nestedComponent(component, nested) {
    Object.keys(nested).forEach(key => {
        component[key] = nested[key];
    });
    return component;
}
exports.default = nestedComponent;
